import { inject, injectable } from "@launchtray/tsyringe-async";
import { ICanvasScaler } from "../../../../../canvas/ICanvasScaler";
import { Viewable } from "../../../../../scene/viewable/Viewable";
import { Web3Model } from "../../../../../web3/models/Web3Model";
import { ILogger } from "../../../../logger/ILogger";
import { PromiseCompletionSource } from "../../../../../shared/async/PromiseCompletionSource";
import { SignMessageView } from "./view/SignMessageView";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { ISignMessageController } from "./controllers/ISignMessageController";
import { ExternalWalletType } from "../../../../../web3/externalWallets/ExternalWalletType";
import { SignMessageResourcePackage } from "./resources/SignMessageResourcePackage";

export type SignMessageOptions = {
    address: string;
    walletType?: ExternalWalletType
}

@injectable()
export class SignMessageScene extends Viewable<string> {
    public constructor(
        commonResources: CommonResourcesPackage,
        loginResourcePackage: SignMessageResourcePackage,
        @inject("ISignMessageController") signMessageController: ISignMessageController,
        web3Model: Web3Model,
        @inject("SignMessageOptions") options: SignMessageOptions,
        @inject("ICanvasScaler") canvasScaler: ICanvasScaler,
        @inject("ILogger") logger: ILogger
    ) {
        super();
        const pcs = new PromiseCompletionSource<string>();
        this.view = new SignMessageView(commonResources, loginResourcePackage, signMessageController, web3Model, options, canvasScaler, logger, pcs);
        pcs.result.then((result) => {
            this.operationControls.complete(result);
        }, (e: unknown) => {
            this.operationControls.error(e);
        });
    }
}